import type { TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

import { Stages } from '..';
import { type TransformMetadataBackendPlacementStage } from './types';
import type { AnyBackendPlacementStageInput } from '../../../../create-placement/types';

export const applyTransformMetadata =
	(transformMetadata?: TransformMetadataBackendPlacementStage) =>
	async (params: AnyBackendPlacementStageInput) => {
		const transformedMetadata = await Stages.maybe(transformMetadata)(params);
		const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';

		return Stages.mergeMetadata<TransformMetadataResult>((original, metadata) => ({
			...original,
			enrichedAttributes: {
				'in-app': {
					[placementId]: metadata,
				},
			},
		}))(params, transformedMetadata);
	};
